import { component } from "picoapp";

export const fairingSurvey = component(async (node) => {
  window.addEventListener("DOMContentLoaded", function () {
    // API key (Publishable API key located on your Account page)
    const API_KEY = node.dataset.fairingApiKey;

    // Select the DOM element to insert the question into
    const TARGET_ELEMENT = node.querySelector<HTMLDivElement>(
      "[fairing-qs-target]"
    );

    if (!TARGET_ELEMENT || !API_KEY) {
      return;
    }
    // The ID of the NPS question (Fairing can provide)
    const NPS_QUESTION_ID = node.dataset.fairingQuestionId;

    // Parse the URL query parameters
    const query = new URLSearchParams(window.location.search);
    // Get the order ID from the URL query parameters
    const orderId = query.get("i") ?? query.get("I");
    // Get the rating from the URL query parameters
    const rating = query.get("r");

    // If the order ID is not in the URL, we can't do anything useful, so we just abort.
    if (!orderId) {
      console.warn("The order ID is missing from the URL query string.");
      return;
    }

    // If the rating isn't in the URL, we just display the question so the customer can respond.
    // This could happen if they click the link in the email that directs them to "Complete the Survey".
    // That link does not include the rating.
    if (!rating) {
      console.warn("The rating is missing from the URL query string.");
      TARGET_ELEMENT.style.display = "block";
    }

    const transaction = {
      id: orderId,
      source: "survey_landing", // Let Fairing know what value this property is set to
    };

    const fairing = window.Fairing(API_KEY, TARGET_ELEMENT, {
      transaction,
      customer: {},
      config: {
        shopify_order: true,
        host: "app.fairing.co",
      },
    });

    // This starts the Question Stream
    fairing.nextQuestion();

    window.addEventListener("fairing.question.displayed", (event) => {
      if ((event as CustomEvent).detail.question_id !== NPS_QUESTION_ID) {
        TARGET_ELEMENT.style.display = "block";
        return;
      }

      // If the rating isn't provided, we can't auto-submit the form, so the customer will have to provide it manually.
      if (!rating) {
        return;
      }

      const form = TARGET_ELEMENT?.querySelector("form");

      if (!form) {
        console.error("Form not found within the target element.");
        return;
      }

      const option = form.querySelector<HTMLInputElement>(
        `[data-enquire-response="${rating}"]`
      );

      // If the rating isn't a valid rating, we abort. You may want to show some other content in this scenario so the page isn't blank or so it appears that the customer has provided a response.
      if (!option) {
        console.warn("Invalid rating provided. Not submitting response.");
        return;
      }

      option.checked = true;
      form.requestSubmit();
    });

    // Once the question has been answered, show the form so that the follow-up question is displayed.
    window.addEventListener("fairing.question.answered", () => {
      TARGET_ELEMENT.style.display = "block";
    });

    window.addEventListener("fairing.questionStream.noQuestions", () => {
      const ANSWERED_MESSAGE_ELEMENT = node.querySelector<HTMLDivElement>(
        "#fairing-already-answered"
      );

      if (ANSWERED_MESSAGE_ELEMENT) {
        ANSWERED_MESSAGE_ELEMENT.style.display = "block";
      }
    });
  });
});
